<template>
  <div class="rewards">
    <Header />
    <div class="rewards-main">
      <div class="rewards-main-left">
        <div class="boxs-title">इनाम प्रकार</div>
        <div class="boxs">
          <div
            :class="[
              'boxs-item',
              {
                'boxs-item-active': index === rewardTypeIndex,
              },
            ]"
            v-for="(item, index) in rewardTypeList"
            :key="index"
            @click="changeType(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="boxs-Cost">लागत</div>
        <div class="boxs">
          <div
            :class="['boxs-item', { 'boxs-item-active': index === costIndex }]"
            v-for="(item, index) in costList"
            :key="index"
            @click="changeCostIndex(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="boxs-redeemable">
          <div>आपके पास <span>$ 1</span>की विनिमय राशि है।</div>
          <div class="agree">
            <div
              :class="checked ? 'box bgcolor' : 'box'"
              @click="changeChecked"
            >
              <img
                v-if="checked"
                class="check"
                src="@/assets/pcImg/check.png"
                alt=""
              />
            </div>
            <div class="afford">मेरे द्वारा वहन की जा सकने वाली कार्ड दिखाएँ।</div>
          </div>
        </div>
      </div>
      <div class="rewards-main-right">
        <div class="search">
          <input
            type="text"
            placeholder="फिर ढूंढें"
            @blur="searchRewards"
            v-model="name"
          />
          <img src="@/assets/pcImg/other/search.png" alt="图片" />
        </div>
        <div class="rewards-dropdown-box">
          <div class="dropdown-box">
            <div class="title">
              <div v-if="rewardTypeIndex === null">इनाम का प्रकार</div>
              <div v-if="rewardTypeIndex === 0">इलेक्ट्रॉनिक गिफ्ट कार्ड</div>
              <div v-if="rewardTypeIndex === 1">अन्य</div>
              <img
                @click="rewardTypeShow = !rewardTypeShow"
                src="@/assets/pcImg/other/down.png"
                alt="图片"
                :class="rewardTypeShow ? 'reward-type-show' : ''"
              />
            </div>
            <div class="contents">
              <div
                class="content"
                v-for="(item, index) in rewardTypeList"
                :key="index"
                @click="changeType(index)"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="dropdown-box-cost">
            <div class="title">
              <div v-if="costIndex === null">लागत</div>
              <div v-if="costIndex === 0">$10 या उससे कम</div>
              <div v-if="costIndex === 1">$10 - $50</div>
              <div v-if="costIndex === 2">$50 या अधिक</div>
              <img
                @click="costShow = !costShow"
                src="@/assets/pcImg/other/down.png"
                alt="图片"
                :class="costShow ? 'cost-show-show' : ''"
              />
            </div>
            <div class="cost-contents">
              <div
                class="content"
                v-for="(item, index) in costList"
                :key="index"
                @click="changeCostIndex(index)"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="cards">
          <div
            class="card"
            v-for="(item, index) in list"
            :key="index"
            @click="skip(item)"
          >
            <img class="card-img-top" :src="item.thumbImageUrl" alt="图片" />
            <div class="card-title">{{ item.name }}</div>
            <div class="card-title">$ {{ item.displayPoints / 100 }}</div>
            <div class="arrowhead">
              <img src="@/assets/pcImg/other/arrowhead-right.png" alt="图片" />
            </div>
          </div>
          <div v-if="list.length === 0" class="no-data">कोई डेटा उपलब्ध नहीं है</div>
        </div>

        <div class="pagination">
          <el-pagination
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            :current-page="page"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import { Gifts } from "@/api/api.js";
import { Notify } from "vant";
export default {
  components: { Header, Footer },
  data() {
    return {
      rewardTypeList: ["इलेक्ट्रॉनिक गिफ्ट कार्ड", "अन्य"],
      rewardTypeIndex: null,
      rewardTypeShow: false,
      costIndex: null,
      costList: ["$10 या उससे कम", "$10 - $50", "$50 या अधिक"],
      costShow: false,
      radio: "",
      checked: false,
      list: [],
      cateId: "",
      name: "",
      minPoints: "",
      maxPoints: "",
      size: 3,
      total: null,
      page: 1,
    };
  },
  watch: {
    rewardTypeShow: {
      handler() {
        if (this.rewardTypeShow) {
          document.getElementsByClassName("contents")[0].style.height =
            40 * this.rewardTypeList.length + "px";
        } else {
          document.getElementsByClassName("contents")[0].style.height = 0;
        }
      },
    },
    costShow: {
      handler() {
        if (this.costShow) {
          document.getElementsByClassName("cost-contents")[0].style.height =
            40 * this.costList.length + "px";
        } else {
          document.getElementsByClassName("cost-contents")[0].style.height = 0;
        }
      },
    },
  },
  methods: {
    currentChange(e) {
      console.log(1234, e);
      this.page = e;
      this.getList();
    },
    changeType(index) {
      this.rewardTypeIndex = index;
      if (index === 0) this.cateId = 1;
      if (index === 1) this.cateId = 0;
      this.page = 1;
      this.getList();
    },
    changeCostIndex(index) {
      this.costIndex = index;
      this.checked = false;
      if (index === 0) {
        this.maxPoints = 1000;
        this.minPoints = "";
      }
      if (index === 1) {
        this.maxPoints = 5000;
        this.minPoints = 1000;
      }
      if (index === 2) {
        this.maxPoints = "";
        this.minPoints = 5000;
      }
      this.page = 1;
      this.getList();
    },
    changeChecked() {
      this.checked = !this.checked;
      this.costIndex = null;
      this.page = 1;
      let balance = JSON.parse(localStorage.getItem("accountInfo")).balance;
      if (this.checked) {
        this.maxPoints = balance;
        this.minPoints = "";
        this.getList();
      } else {
        this.maxPoints = "";
        this.minPoints = "";
        this.getList();
      }
    },
    searchRewards() {
      this.page = 1;
      this.getList();
    },
    skip(data) {
      console.log(123, data);
      // this.$router.push({
      //   path: url,
      // });
      // if (data.categoryId === 0) {
      //   this.$router.push({
      //     path: "/rewards/paypal",
      //   });
      // }
      this.$router.push({
        path: `/rewardsPaypal?id=${data.id}&number=${data.displayPoints / 100}`,
      });
    },
    getList() {
      const params = {
        page: this.page,
        size: this.size,
        cateId: this.cateId,
        maxPoints: this.maxPoints,
        minPoints: this.minPoints,
        name: this.name,
      };
      Gifts(params).then((res) => {
        if (res.code === 200) {
          this.list = res.data.list;
          this.total = parseInt(res.data.pagebar.totalSize);
        } else {
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style scoped>
.rewards {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.rewards-main {
  display: flex;
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
.rewards-main-left .boxs-title {
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 20px;
}
.rewards-main-left .boxs-Cost {
  font-size: 10px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}
.boxs-redeemable {
  font-size: 7.5px;
  margin-top: 30px;
  padding: 5px;

  background: #e9effd;
  border-radius: 1.25px;
  text-align: center;
}
.agree {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: 8.75px;
  margin-top: 15px;
  margin-bottom: 5px;
}
.agree > .box {
  width: 9.375px;
  height: 9.375px;
  background-color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.625px solid #999;
}
.agree > .bgcolor {
  background-color: #2e67ea;
  border: 0.625px solid #2e67ea;
}
.check {
  width: 5px;
  height: 5px;
}
.agree > .afford {
  font-size: 7.5px;
}
.boxs-redeemable span {
  font-weight: bold;
  font-size: 10px;
}
.boxs {
  display: flex;
  flex-direction: column;
  font-size: 8px;
}
.boxs-item {
  width: 63.75px;
  height: 25px;
  line-height: 25px;
  padding-left: 10px;
  cursor: pointer;
  text-align: left;
}
.boxs-item-active {
  background: rgba(46, 103, 234, 0.1);
  color: #2e67ea;
}
.cost-item {
  font-size: 10px;
  margin-top: 10px;
  padding-left: 8.75px;
}
.rewards-main-left {
  width: 150px;
}

/* 右侧 */
.rewards-main-right {
  width: 100%;
}
.search {
  float: right;
  position: relative;
}
.search > input {
  border: 0.625px solid #dddddd;
  border-radius: 2.5px;
  height: 23.75px;
  width: 133.125px;
  line-height: 23.75px;
  padding-left: 10px;
  padding-right: 20px;
  font-size: 8.75px;
  color: #232323;
}
.search > img {
  width: 15px;
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.cards {
  display: flex;
  justify-content: flex-start;
  margin-top: 50px;
  padding: 0 50px;
}
.card {
  width: 122.5px;
  /* height: 158.75px; */
  padding: 7.5px;
  background: #ffffff;
  box-shadow: 0px 1.25px 6.25px 0.625px rgba(0, 0, 0, 0.1);
  border-radius: 2.5;
  cursor: pointer;
  margin-right: calc((100% - 412.5px) / 2);
}
.card:nth-of-type(3n) {
  margin-right: 0;
}
.card-img-top {
  width: 100%;
  height: auto;
}
.card-title {
  font-size: 10px;
  font-weight: bold;
  margin-top: 11px;
}
.arrowhead {
  margin-top: 30px;
  width: 100%;
}
.arrowhead img {
  float: right;
  width: 15px;
  cursor: pointer;
}
.no-data {
  width: 100%;
  height: 224.5px;
  line-height: 224.5px;
  text-align: center;
  font-weight: bold;
}
.pagination {
  display: flex;
  justify-content: center;
}
.el-pagination {
  margin-top: 20px;
}
</style>
<style scoped>
/* 移动端 */
.rewards-dropdown-box {
  display: none;
  /* justify-content: flex-start; */
  margin-top: 40px;
}
.dropdown-box {
  width: 120px;
  background-color: #fff;
  /* box-shadow: 0px 9px 28px 1px rgba(0, 0, 0, 0.05); */
  margin-right: 20px;
}
.dropdown-box .title {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 10px;
}
.dropdown-box .contents {
  height: 0;
  transition: height 0.3s;
  overflow: hidden;
}
.dropdown-box .content {
  font-size: 10px;
  height: 25px;
  line-height: 25px;
}
.dropdown-box .content:hover {
  background-color: #c6c5c6;
}
.dropdown-box .title > img {
  width: 10px;
  cursor: pointer;
  transition: transform 0.3s;
}
.dropdown-box .title > .reward-type-show {
  transform: rotate(-180deg);
}
.dropdown-box-cost {
  width: 120px;
  background-color: #fff;
  /* box-shadow: 0px 9px 28px 1px rgba(0, 0, 0, 0.05); */
  margin-right: 20px;
  height: auto;
}
.dropdown-box-cost .title {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 10px;
}
.dropdown-box-cost .cost-contents {
  height: 0;
  transition: height 0.3s;
  overflow: hidden;
}
.dropdown-box-cost .cost-contents {
  font-size: 10px;
  height: 0px;
  line-height: 25px;
}
.dropdown-box-cost .content:hover {
  background-color: #c6c5c6;
}
.dropdown-box-cost .title > img {
  width: 10px;
  cursor: pointer;
  transition: transform 0.3s;
}

.dropdown-box-cost .title > .cost-show-show {
  transform: rotate(-180deg);
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1350px) {
  .rewards-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1220px) {
  .rewards-main {
    width: calc(100% - 40px);
    padding: 20px 20px;
  }
}
@media only screen and (max-width: 1140px) {
  .cards {
    padding-right: 0;
    padding-left: 20px;
  }
}
@media only screen and (max-width: 1000px) {
  .rewards-main-left {
    display: none;
  }
  .cards {
    padding-left: 0;
    margin-top: 20px;
  }
  .rewards-dropdown-box {
    display: flex;
  }
}
@media only screen and (max-width: 800px) {
  .cards {
    flex-direction: column;
    align-items: center;
  }
  .card {
    width: 280px;
    margin-bottom: 20px;
    padding: 13px;
    margin-right: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/rewards.vue